import { isUserPaused } from '@cube3/state/src/Hoocs/Uploads/uploadActions';
import { AssetProcessingStates } from '@cube3/common/model/resource-types';
import { Upload } from '@cube3/common/model/schema/resources/file-upload';

/** Parses the upload state from the server and the frontend uploader to a state that can be represented in the grid tile or list item */
export function parseUploadState(
  serverState: AssetProcessingStates,
  upload: Upload
): AssetProcessingStates {
  const mappedState = serverState;
  let resolvedState: AssetProcessingStates =
    mappedState || (serverState as AssetProcessingStates);

  if (upload?.failed) {
    if (!(upload?.file instanceof File)) {
      resolvedState = 'AssetUploadStatusUplodadMissing';
    } else {
      resolvedState = 'AssetUploadStatusFailed';
    }
    return resolvedState;
  }

  if (
    ['processing_complete', 'processing_pending', 'processing_failed'].includes(
      mappedState
    )
  ) {
    return mappedState;
  }

  if (upload && upload.active && upload.failed && !upload.tusUpload) {
    resolvedState = 'AssetUploadStatusUplodadInitFailed';
  }
  if (upload && !upload.failed && upload.file?.size && !upload.tusUpload) {
    resolvedState = 'AssetUploadStatusPending';
  }

  if (
    (upload &&
      upload.file?.size &&
      !upload.active &&
      !upload.failed &&
      upload.progress !== 100) ||
    (upload && upload.tusUpload?._aborted)
  ) {
    resolvedState = 'AssetUploadStatusPending';
  }

  if (
    upload &&
    upload.tusUpload &&
    (upload.paused || isUserPaused(upload) === true)
  ) {
    resolvedState = 'AssetUploadStatusPaused';
  }

  // edge case where upload is done, but asset hasn't been polled
  if (
    mappedState === 'AssetProcessingStatusUploading' &&
    upload &&
    upload.progress === 100
  ) {
    resolvedState = 'AssetProcessingStatusPending';
  }

  if (
    mappedState === 'AssetProcessingStatusUploading' &&
    !(upload?.file instanceof File)
    && upload['status'] !== 'succeeded'
  ) {
    resolvedState = 'AssetUploadStatusUplodadMissing';
  }

  return resolvedState;
}
